module.exports = __webpack_public_path__ + "static/currentHero-db73a0672229974895535c436ac816e2.jpg";